import type { z } from "zod";

import { Response } from "~/shared/api";

const zRes = Response.Schema.zSuccessful(200);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
